import { Injectable } from '@angular/core';
import { StorageService } from './storage.service.interface';
import { keys } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService extends StorageService {
  ignoreKeysOnClear: string[] = ['ProposedMeterReading'];

  constructor() {
    super();

    // TODO: add app insight logging
    // if (typeof (Storage) === 'undefined') {
    //   console.error(':: Local storage not available.');
    // }
  }

  setItem(key: string, value: string) {
    const currentValue = localStorage.getItem(key);
    if (currentValue === value) {
      return;
    }

    localStorage.setItem(key, value);
    this.getSubject(key).next(value);
  }

  clear() {
    for (const key of keys(localStorage)) {
      if (this.ignoreKeysOnClear.includes(key)) {
        continue;
      }
      localStorage.removeItem(key);
    }
    super.clear();
  }

  removeItem(key: string): any {
    localStorage.removeItem(key);
  }

  getItem(key: string): any {
    return localStorage.getItem(key);
  }

  resetMeterDataPagination() {
    localStorage.removeItem('lastSelectedPage');
    localStorage.removeItem('lastSelectedPageRef');
  }
}
